import React from 'react';
import { Typography } from 'antd';
import PropTypes from 'prop-types';

const WorkExpTitle = ({ gb_seniority_improvement_conversion }) => {
  return gb_seniority_improvement_conversion === 'sic_banner_change' ? (
    <div>
      <div className='new-mcq-work-exp-title-wrapper'>
        <Typography.Text className="new-mcq-work-exp-title-small">Work Experience Survey</Typography.Text>
      </div>
      <div>
        <Typography.Text className="new-mcq-work-exp-title">Help us match you with the right jobs</Typography.Text>
      </div>
    </div>
  ) : (
    <div className='new-mcq-work-exp-title-wrapper'>
      <Typography.Text className="new-mcq-work-exp-title">Tell us about your work experience</Typography.Text>
    </div>
  );
};

WorkExpTitle.propTypes = {
  gb_seniority_improvement_conversion: PropTypes.string
};

export default WorkExpTitle;
